import * as React from 'react';
import classnames from 'classnames';
import { StickyMobileCtaAndPrice } from '../../../../StickyCta/StickyMobileCtaAndPrice.js';
import { ContactLensesCTA } from '../ContactLensesCTA/ContactLensesCTA.js';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import '../../../../../types/product.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '@swc/helpers';
import '@grandvisionhq/forms';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/state';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/inventory';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import '@grandvisionhq/frk-routing';
import '../../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import '@grandvisionhq/icons';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '../../../../../hooks/use-product-view-history.js';
import '../../../../../slots/context.js';
import '@grandvisionhq/content';
import '../../types/quantity-discounts.js';
import '../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../operations/queries/get-contact-lens-by-prescription.js';
import { LensesPerBox } from '../LensesPerBox/LensesPerBox.js';

const ContactLensesStickyCTA = ({ className  })=>/*#__PURE__*/ React.createElement(StickyMobileCtaAndPrice, {
        className: classnames('contact-lenses-sticky-cta', className),
        cta: /*#__PURE__*/ React.createElement(ContactLensesCTA, {
            className: "contact-lenses-sticky-cta__button"
        }),
        priceSubtitle: /*#__PURE__*/ React.createElement(LensesPerBox, {
            hideTitle: true
        })
    })
;

export { ContactLensesStickyCTA };
//# sourceMappingURL=ContactLensesStickyCTA.js.map
